module.exports = __webpack_public_path__ + "static/fb-de01052bedfd936c422912f6a311d4a0.png";